import React, { memo, useState, useEffect } from 'react'
import { required, useTranslate } from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { supplierServices } from 'src/services/reservation/supplier/supplier.service'
import { useQuery } from 'react-query'
import { orderSuppliers } from '../../helper/sortSuppliersFunction.js'

export const GetHotelFields = memo(({ record }) => {
  const translate = useTranslate()
  const [hotelCountries, setHotelCountries] = useState([])
  const [loadingHotelCountries, setLoadingHotelCountries] = useState(false)
  // const [hotelCities, setHotelCities] = useState([])
  // const [selectedCountries, setSelectedCountries] = useState([])
  // const [loadingHotelCities, setLoadingHotelCities] = useState(false)
  const HOTEL_PRODUCT_TYPE = 1
  const params = {
    operator: 'equal',
    product_type_id: HOTEL_PRODUCT_TYPE,
    limit: 999,
    is_active: true,
  }

  const suppliers = useQuery('ext-hotel-supplier', () => supplierServices.getByParam(params))
  const hotelSource = useQuery('ext-hotel-source', businessRuleServices.getHotelSources)

  const parseContractIdToString = suppliers?.data?.map((elem) => {
    if (elem?.gmx_contract_id !== null && elem?.gmx_contract_id !== undefined) {
      return { ...elem, contract_id: elem.gmx_contract_id.toString() }
    }

    return null
  })?.filter(elem => elem) || []

  useEffect(() => {
    if (record) {
      getCountries(record?.hotel?.country)
    } else {
      getCountries()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getCountries = async (defaultCountries = null) => {
    try {
      setLoadingHotelCountries(true)
      const allCountries = await businessRuleServices.getCountries()
      setHotelCountries(allCountries)
      setLoadingHotelCountries(false)

      // if (defaultCountries) {
      //   getCitiesByDefaultCountry(defaultCountries)
      // }
    } catch (error) {
      setHotelCountries([])
      setLoadingHotelCountries(false)
    }
  }

  // const getCitiesByDefaultCountry = async (countries, currentCities = [], selectedCountries = []) => {
  //   if (Array.isArray(countries)) {
  //     const filteredCountries = countries.filter((elem) => !selectedCountries.includes(elem))

  //     if (filteredCountries.length > 0) {
  //       try {
  //         setLoadingHotelCities(true)
  //         const promises = filteredCountries.map(businessRuleServices.getCitiesByCountry)
  //         Promise.all(promises).then((allCities) => {
  //           setHotelCities([...currentCities, ...allCities.flat()])
  //         })
  //         setLoadingHotelCities(false)
  //       } catch (error) {
  //         setLoadingHotelCities(false)
  //       }
  //     } else {
  //       setHotelCities((current) => current.filter((elem) => countries.includes(elem.id_country_code)))
  //     }

  //     setSelectedCountries(countries)
  //     return
  //   }
  // }

  // const getCities = async (e) => {
  //   let {
  //     target: { value },
  //   } = e
  //   const contryId = value.find((elem) => !selectedCountries.includes(elem))
  //   if (contryId) {
  //     try {
  //       setLoadingHotelCities(true)
  //       const allCities = await businessRuleServices.getCitiesByCountry(contryId)
  //       setHotelCities((current) => [...current, ...allCities])
  //       setLoadingHotelCities(false)
  //     } catch (error) {
  //       setLoadingHotelCities(false)
  //     }
  //   } else {
  //     setHotelCities((current) => current.filter((elem) => value?.includes(elem.id_country_code)))
  //   }

  //   setSelectedCountries(value)
  // }
  return (
    <Grid container spacing={3}>
      <EditInputsWrap label={translate('ra.field.supplier')} required>
        {suppliers.isLoading ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='hotel.supplier'
            options={orderSuppliers(parseContractIdToString || [], record?.hotel?.supplier?.include ?? [], 'contract_id')}
            label=''
            optionsText={['name']}
            optionValue='contract_id'
            size='small'
            multiple
            showSearch
            showAllOption
            defaultValue={record ? record?.hotel?.supplier : undefined}
            validate={[required()]}
          />
        )}
      </EditInputsWrap>
      <EditInputsWrap label={translate('ra.field.country')} required>
        {loadingHotelCountries ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='hotel.country'
            options={hotelCountries || []}
            label=''
            optionsText={['country_name']}
            optionValue='country_code'
            size='small'
            // onChange={getCities}
            multiple
            showAllOption
            showSearch
            defaultValue={record ? record?.hotel?.country : undefined}
            validate={[required()]}
          />
        )}
      </EditInputsWrap>
      {/* <EditInputsWrap label={translate('ra.field.city')} required>
        {loadingHotelCities ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='hotel.city'
            options={hotelCities}
            label=''
            optionsText={['location_name']}
            optionValue='location_id'
            size='small'
            multiple
            showSearch
            validate={[required()]}
            defaultValue={record ? record?.hotel?.city : undefined}
          />
        )}
      </EditInputsWrap> */}
      <EditInputsWrap label={translate('ra.field.source')} required>
        {hotelSource.isLoading ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source='hotel.source_relation'
            options={hotelSource.data || []}
            label=''
            optionsText={['long_name']}
            size='small'
            multiple
            showSearch
            defaultValue={record ? record?.hotel?.source_relation : undefined}
            validate={[required()]}
          />
        )}
      </EditInputsWrap>
    </Grid>
  )
})
